import { SelectProps as AntSelectProps, Select as AntdSelect } from 'antd';
import { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { SelectValue } from 'antd/lib/select';
import { Tag } from '..';
import React, { ReactElement, ReactNode } from 'react';

import './select.scss';

const { Option, OptGroup } = AntdSelect;

export interface TagRenderProps extends CustomTagProps {
    isReverse?: boolean;
}

function defaultTagRender(props: TagRenderProps) {
    return (
        <Tag size="large" {...props}>
            {props.label}
        </Tag>
    );
}

interface SelectProps<T extends SelectValue> extends AntSelectProps<T> {
    isTagReverse?: boolean;
    tagRender?: (props: TagRenderProps) => ReactElement;
    modifiers?: ReactNode | Element;
}

const defaultDropdownAlign = {
    points: ['tr', 'br'],
    overflow: {
        adjustX: 0,
    },
};

const Select = <T extends SelectValue = SelectValue>(props: SelectProps<T>) => {
    const className = props.modifiers ? 'rain-select rain-select-with-modifiers' : 'rain-select';
    const { isTagReverse, ...rest } = props;
    return (
        <div className={className}>
            <AntdSelect<T>
                dropdownMatchSelectWidth={props.dropdownMatchSelectWidth ?? true}
                dropdownAlign={defaultDropdownAlign}
                {...rest}
                tagRender={(tagProps: CustomTagProps) => {
                    return (props.tagRender || defaultTagRender)({ isReverse: isTagReverse, ...tagProps });
                }}>
                {props.children}
            </AntdSelect>
            {props.modifiers && <div className="rain-select-modifiers">{props.modifiers}</div>}
        </div>
    );
};

Select.Option = Option;
Select.OptGroup = OptGroup;

export default Select;
